var PrimaryPlanSelectionFactory = function ($resource, $window) {
  var retrievePlansAvailableForPrimaryPlan =
    "/participant-web-services/rest/partialauth/oneId/retrivePlansAvailableForPrimaryPlan";
  var chooseDefaultAndRefresh =
    "/participant-web-services/rest/partialauth/oneId/refreshSessionWithContextSwitch/:indId/:dbName/:accuCode/:updatedefault";
  var hasOutsideAssetsData =
    "/participant-web-services/rest/outsideAssets/hasOutsideAssets";

  return {
    retrievePlansAvailableForPrimaryPlan: $resource(
      __baseApiUrl__ + retrievePlansAvailableForPrimaryPlan,
      {},
      {
        query: {
          method: "GET"
        },
      }
    ),

    chooseDefaultAndRefresh: $resource(
      __baseApiUrl__ + chooseDefaultAndRefresh,
      {
        indId: "@indId",
        dbName: "@dbName",
        accuCode: "@accuCode",
        updatedefault: "@updatedefault",
      },
      {
        query: {
          method: "GET",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    hasOutsideAssets: $resource(
      __baseApiUrl__ + hasOutsideAssetsData,
      {},
      {
        query: {
          method: "GET"
        },
      }
    ),
  };
};

PrimaryPlanSelectionFactory.$inject = ["$resource", "$window"];
export default PrimaryPlanSelectionFactory;
